<div class="main-container" [ngClass]="componentData?.style | stickyHeader: pathname : scrollY">
  <div class="home-nav">
    <div class="home-nav__container home-nav__container--full-width">
      <div class="home-nav__logo light" [ngClass]="{ 'home-nav__logo--modern': componentData?.style === 'modern' }">
        <a
          id="skip-link"
          role="link"
          class="hidden-focusable-element"
          [href]="skipLinkPath"
          [translate]="'GlobalNav:SkiptoContent'"
        >
          Skip to content
        </a>
        <a
          *ngIf="componentData?.logo"
          href
          role="link"
          id="global-nav-logo"
          [class.holdingpage-nav-logo]="isHoldingPage ? true : null"
          [routerLink]="componentData?.logoClick === 'homepage' ? [''] : []"
          (click)="logoClick(componentData?.logoClick)"
          (accessibleClick)="logoClick(componentData?.logoClick)"
        >
          <img
            *ngIf="siteLogo$ | async as siteLogo"
            alt="{{ clientName }} Concierge Service delivered by TEN"
            class="home-nav__logo__image"
            [class.modern__logo-image]="componentData?.buttonContainerStyle === 'modern'"
            [src]="siteLogo"
          />
        </a>
      </div>

      <div class="home-nav__provider">
        <!-- Platform provider info. -->
        <div
          *ngIf="showPlatformProvider && platformProviderType === 'provider' && isAccessHrt"
          class="platform-provider"
          [class.provider-tab-view]="showRegisterButton"
        >
          <div class="platform-provider__text" [translate]="'GlobalNav:ServiceProvidedBy'">Service provided by</div>
          <div
            role="img"
            class="platform-provider__icon"
            [attr.aria-label]="'GlobalNav:ServiceProvidedBy' | translate"
          ></div>
        </div>
        <div
          *ngIf="showPlatformProvider && platformProviderType === 'delivered'"
          class="platform-provider"
          [class.provider-tab-view]="showRegisterButton"
        >
          <div class="platform-provider__text" [translate]="'GlobalNav:DeliveredBy'">Delivered by Ten</div>
        </div>
        <div
          *ngIf="showPlatformProvider && platformProviderType === 'partnership'"
          class="platform-provider"
          [class.provider-tab-view]="showRegisterButton"
        >
          <div class="platform-provider__text" [translate]="'GlobalNav:InPartnerShipWith'">In partnership with</div>
          <div
            role="img"
            class="platform-provider__icon"
            [attr.aria-label]="'GlobalNav:ServiceProvidedBy' | translate"
          ></div>
        </div>

        <div class="home-nav__sub-menu" [ngClass]="{ 'home-nav__sub-menu--modern': componentData?.style === 'modern' }">
          <button
            id="top_button_login"
            aria-label="login"
            mat-raised-button
            color="accent"
            (click)="loginLink()"
            class="nav-login-button"
            [class.holdingpage-login-btn]="isHoldingPage ? true : null"
            *ngIf="showLogInBtn && !showRegisterButton"
          >
            {{ 'HomeNav:HomeNavLogin' | translate }}
          </button>
          <div class="button-container" *ngIf="showLogInBtn && showRegisterButton && !isMobile">
            <button
              *ngIf="showSelfReg"
              mat-raised-button
              color="accent"
              [attr.aria-labelledby]="'registerButton'"
              (click)="openEligibilityCheck()"
              class="register-button"
              id="top_button_register"
              [innerHTML]="(customisableVariables$ | async).MTLS_PreLogin_Register_Now"
            ></button>
            <button
              mat-stroked-button
              color="accent"
              (click)="loginLink()"
              [attr.aria-labelledby]="'logInText'"
              class="log-in-button"
              id="top_button_login"
              [innerHTML]="(customisableVariables$ | async).MTLS_PreLogin_Login"
            ></button>
            <ng-container
              *ngIf="showHomepageSelectorDropDown && !isMobile"
              [ngTemplateOutlet]="countrySelector"
            ></ng-container>
          </div>
          <div
            *ngIf="isMobile && showLogInBtn && showRegisterButton"
            class="global-nav__icon-menu-wrap"
            [class.global-nav__icon-menu-wrap--modern]="componentData?.iconMenuStyle"
          >
            <a
              class="global-nav__icon-menu-item"
              aria-label="menu"
              role="link"
              data-toggle="modal"
              tabindex="0"
              data-target="#id01"
              tourAnchor="global-nav.menu"
              id="global-nav.menu"
              (accessibleClick)="toggleBurgerMenu(true)"
            >
              <img src="assets/images/header/menu.svg" alt="" *ngIf="componentData?.iconMenuStyle === 'modern'" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  role="button"
  aria-label="Close"
  class="parent-overlay"
  *ngIf="menuState === 'in'"
  (accessibleClick)="toggleBurgerMenu(false)"
></div>

<nav [@slideInOut]="menuState" class="overlay" *ngIf="showMobileNavOverlay" id="mobile-nav" aria-label="Main">
  <ten-mobile-nav
    [siteSettingsLoaded]="siteSettingsLoaded"
    [showFeatureNavLinks]="false"
    [menuList]="menuList$ | async"
    [isUserLoggedIn]="false"
    (closed)="toggleBurgerMenu(false)"
    (login)="loginLink()"
    (register)="openEligibilityCheck()"
  >
  </ten-mobile-nav>
</nav>
<ng-template #countrySelector>
  <span class="vr mx-3"></span>
  <button
    mat-icon-button
    [attr.aria-labelledby]="'countrySelector'"
    cdk-overlay-origin
    #countryLanguageSelect="cdkOverlayOrigin"
    id="top_button_country_selector"
    (click)="isCountrySelectVisible = !isCountrySelectVisible"
    [disableRipple]="true"
  >
    <mat-icon class="fi fi-{{ (selectedSite | async)?.display_country_code | lowercase }} fis"></mat-icon>
    <mat-icon>arrow_drop_down</mat-icon>
    <ng-template
      cdk-connected-overlay
      cdkConnectedOverlayPanelClass="ten-country-selector__overlay"
      [cdkConnectedOverlayOrigin]="countryLanguageSelect"
      cdkConnectedOverlayHasBackdrop
      [cdkConnectedOverlayOpen]="isCountrySelectVisible"
      (backdropClick)="isCountrySelectVisible = false"
      [cdkConnectedOverlayPositions]="positionsCountrySelectMenu"
    >
      <div class="ten-country-selector__panel container m-0 p-4">
        <ten-country-selector [init]="selectedSite" (emitSiteDetails)="updateSite($event)"></ten-country-selector>
      </div>
    </ng-template>
  </button>
</ng-template>
